<template>
  <div class="col-lg-10 col-lg-offset-1">
    <div class="hpanel">
      <div class="col-lg-12" style="margin-top: 20%">
        <div class="hpanel">
          <div class="panel-body">
            <div class="">Generate Pivot Csv</div>
            <div class="m-t-sm">
              <form @submit.prevent="requestReport()">
                <div class=" row">
                    <div class="col-md-5">
                      <select name="" id="" class="form-control">
                        <option value="" selected disabled>Select Report</option>
                        <option value="Member">Members Report</option>
                      </select>
                    </div>
                    <div class="col-md-5">
                     <div class="row">
                       <div class="col-md-6">
                         <datepicker :readonly="true" v-model="report.start_date" format="YYYY-MM-DD"></datepicker>
                       </div>
                       <div class="col-md-6">
                         <datepicker :readonly="true" v-model="report.end_date" format="YYYY-MM-DD"></datepicker>
                       </div>
                     </div>
                    </div>
                    <div class="col-md-2">
                      <div class="input-group-btn">
                        <button class="btn btn-default" type="submit">Generate</button>
                      </div>
                    </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from 'vue-date-picker'
export default {
  data () {
    return {
      report: {
        start_date: '',
        end_date: ''
      }
    }
  },
  methods: {
    requestReport: function () {
      console.log(this.report)
    }
  },
  components: { datepicker }
}
</script>

<style>

</style>
